import React, { Component } from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import InformationAction from '../../home/actions/InformationAction'

class InformationPanel extends Component {
	constructor(props) {
		super(props)
	}

	close = (event, reason) => {
		if (reason && reason !== 'clickaway') {
			this.props.reset()
		}
	}

	shouldComponentUpdate(nextProps) {
		return (
			!isEqual(this.props.message, nextProps.message) ||
			!isEqual(this.props.open, nextProps.open)
		)
	}

	render() {
		return (
			<div>
				<Snackbar
					open={ this.props.open }
					onClose={ this.close }
					autoHideDuration={ 4000 }
					ContentProps={ {
						'aria-describedby': 'information-panel'
					} }
					message={ <span id='information-panel'>{ this.props.message }</span> }
				/>
			</div>
		)
	}
}

InformationPanel.propTypes = {
	message: PropTypes.string,
	open: PropTypes.bool,
	reset: PropTypes.func
}
InformationPanel.defaultProps = {
	message: '',
	open: false
}
const mapStateToProps = store => {
	return {
		message: store.InformationReducer.message,
		open: store.InformationReducer.open
	}
}
const mapDispatchToProps = {
	reset: InformationAction.reset
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(InformationPanel)



// WEBPACK FOOTER //
// ./src/components/information/InformationPanel.js